import React from 'react'
import { type ContactData } from '../server/utils/getArticlesData'

import Card from '../components/Card'
import CustomLink from './CustomLink'

const ContactCard: React.FC<ContactData> = ({
  title,
  items,
  links,
  name,
  avatarUrl,
  role
}) => {
  return (
    <Card className="contact-card">
      {title && <h4>{title}</h4>}
      {name ? (
        <div className="contact-card__contact">
          {avatarUrl ? (
            <div className="contact-card__contact-avatar">
              <img src={avatarUrl} alt={name} />
            </div>
          ) : null}
          <div className="contact-card__contact-info">
            <p>{name}</p>
            {role && <span>{role}</span>}
          </div>
        </div>
      ) : null}
      {items?.length ? (
        <ul className="contact-card__info">
          {items.map(({ label, href, value }, index) => (
            <li key={index}>
              <span>{label}</span>
              <a href={href}>{value}</a>
            </li>
          ))}
        </ul>
      ) : null}

      {links?.length && links?.some((link) => link.href) ? (
        <ul className="contact-card__social">
          {links.map(
            (link, index) =>
              link.href && <CustomLink key={index} type="social" {...link} />
          )}
        </ul>
      ) : null}
    </Card>
  )
}

export default ContactCard
